import { GET } from './api-utils'
import { getPrivateBaseUrls } from '../../common/environment-configs'

const metadataCall = async (baseUrl) => {
  if (baseUrl === undefined || baseUrl == null) {
    return
  }
  return await GET(baseUrl + '/amiga/metadata').then((response) => {
    return response ? response.data : null
  })
}

export const getMetadata = async (env) => {
  const stores = {}
  const requests = []
  const baseUrls = getPrivateBaseUrls(env)

  for (const brand in baseUrls) {
    requests.push(metadataCall(baseUrls[brand]).then((result) => { stores[brand] = result }
    ))
  }
  await Promise.allSettled(requests)
  return stores
}
